import { FC } from 'react';
import { observer } from 'mobx-react';

import { useDependencies } from '@servicetitan/react-ioc';
import { SingleOptionProps } from '@servicetitan/design-system';

import { MessageStatus } from '../api/telecom.api';
import { OutboundMessagesStore } from '../stores/outbound-messages.store';
import { MultiValueFilter } from '../../components/tenants/multi-value-filter/multi-value-filter';
import { messageStatusDisplayNames } from '../utils/enum-display.utils';

const statusOptions: SingleOptionProps[] = Object.entries(messageStatusDisplayNames).map(
    ([status, label]) => ({
        value: Number(status) as MessageStatus,
        label,
    }),
);

export const StatusFilter: FC = observer(() => {
    const [store] = useDependencies(OutboundMessagesStore);

    const handleApply = (selectedValues: MessageStatus[]) => {
        store.filterByStatus(selectedValues);
    };

    return (
        <MultiValueFilter
            label="Status"
            onApply={handleApply}
            options={statusOptions}
            appliedValues={store.statusFilter}
        />
    );
});
